import { updateItems } from '@/mocks/homeData';

const tagColors: Record<string, string> = {
  '最新': 'bg-primary-100 text-primary-700',
  '独家': 'bg-accent-100 text-accent-800',
  '热门': 'bg-primary-100 text-primary-700',
  '重磅': 'bg-accent-100 text-accent-800',
  '更新': 'bg-secondary-100 text-secondary-700',
  '数据': 'bg-secondary-100 text-secondary-700',
  '新系列': 'bg-primary-100 text-primary-700',
  '联动': 'bg-accent-100 text-accent-800',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-4xl">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
            最新快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            实时追踪暴走黑料与黑料社最新动态
          </p>
        </div>

        <div className="relative pl-8 md:pl-10">
          <div className="absolute left-3 md:left-[15px] top-2 bottom-2 w-0.5 bg-background-300"></div>

          <div className="space-y-6">
            {updateItems.map((item, idx) => (
              <div key={item.id} className="relative">
                <div
                  className={`absolute left-[-1.25rem] md:left-[-1.625rem] top-1.5 w-3 h-3 rounded-full border-2 ${
                    idx === 0
                      ? 'bg-primary-500 border-primary-500'
                      : 'bg-background-50 border-primary-400'
                  }`}
                ></div>
                <div className="flex items-start gap-3 flex-wrap">
                  <span className="text-xs text-foreground-400 font-mono whitespace-nowrap pt-0.5">
                    {item.time}
                  </span>
                  <span
                    className={`inline-block px-2 py-0.5 rounded text-xs font-semibold whitespace-nowrap ${
                      tagColors[item.tag] || 'bg-secondary-100 text-secondary-700'
                    }`}
                  >
                    {item.tag}
                  </span>
                </div>
                <p className="mt-1.5 text-sm md:text-base text-foreground-800 leading-relaxed font-medium">
                  {item.title}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}